<template>
  <div>
    <a-row>
      <g-master name="Identificación Personal"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                @action="masterAction"
                modalWidth="100%"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Posibles cargos que puede ocupar a futuro (proyectar a 3 años)')"
                          :selectConfig="{mode:'multiple'}"
                          :formItemConfig="fiOptions"
                          endpoint="jobs"
                          :decorator="['position', { rules: [{ required: true, message: 'Valor requerido' }] }]">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['id_emp'],
    data () {
      return {
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'identificacion_potencial',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'eliminar',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'delete'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            selectedRows: [],
            columns: [
              {
                title: 'Cargos que puede ocupar a futuro (proyectar a 3 años)',
                align: 'center',
                dataIndex: 'cargo_desc'
              }
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'eliminar':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('identificacion_potencial/-1', {
                    data: {
                      id_emp: action.record.id_emp,
                      position: action.record.position
                    }
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/IdentificacionPersonal.vue